import { useEffect, useState } from "react";

/**
 * Hook para evaluar una media query CSS y re-renderizar cuando cambia.
 * Útil para detección de breakpoints (móvil/tablet/desktop) en componentes.
 *
 * @param query Media query CSS válida, p.ej. "(max-width: 639px)"
 * @returns `true` si la media query coincide actualmente.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
